

export default class AudiofileTranslationResponse  {
	LangCode?: string = '';
	Name?: string = '';
	Index: number = 0;
	constructor(obj?: Partial<AudiofileTranslationResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
